import * as THREE from 'three'
import { useRef } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { Instances, Instance, OrbitControls } from '@react-three/drei'
import inst from "./inst"
import * as Tone from 'tone'

let notes = ["C", "D", 'E', 'G']
let octaves = [3]
let allNotes = new Array(notes.length * octaves.length).fill().fill().map((val, i) => {
  return notes[i % notes.length] + octaves[Math.floor(i / notes.length)]
})

let lerp = THREE.MathUtils.lerp
let getRand = (arr) => arr[Math.floor(Math.random() * arr.length)]

const color = new THREE.Color()
let vec = new THREE.Vector3()
let amt = 40;

let mut = {
  radMult: 1,
  radAdd: 0,
  height: 1,
  parts: [],
  partHits: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  offsets: new Array(amt).fill().map(() => 0),
  scales: new Array(amt).fill().map(() => 1),
  lines: new Array(amt).fill().map(() => 1),
  ys: new Array(amt).fill().map(() => 1),
  pos0: false,
  pos1: false,
  tp: Math.PI * 2,
  size: 1.5,
  speed: 5,
  lower: false,
  inverted: false,
  rot: 0,
  mode: 0,
  forward: false
}

let createPart = (data, loopEnd, len, i) => {
  let note = getRand(allNotes)
  let note2 = getRand(allNotes)
  let notef = Tone.Frequency(note).toFrequency()
  let note2f = Tone.Frequency(note2).toFrequency()
  const part = new Tone.Part(((time, val) => {
    if (mut.forward) {
      mut.partHits[i]++
    } else {
      mut.partHits[i]--
    }
    let m = 20
    let extra = false
    if (mut.lowers[Math.abs(mut.partHits[i]) % mut.lowers.length]) {
      extra = true
    }
    let sz = mut.lowers[Math.abs(mut.partHits[i]) % mut.lowers.length] ? 1 : 1.25
    // let freq = s + Math.abs(mut.pos0[0] + mut.pos0[1] * m)
    // let freq2 = s + Math.abs(mut.pos1[0] + mut.pos1[1] * m)
    let freq = notef * sz
    let freq2 = note2f * sz
    let freq3 = freq * 2
    let freq4 = freq2 * 2

    let vel = 0.1 + Math.abs(mut.pos0[0]) * 0.1
    let vel2 = 0.1 + Math.abs(mut.pos1[1]) * 0.1
    let s = extra ? 6 : 4
    if (mut.mode === 1) {
      mut.scales[Math.abs(mut.partHits[i]) % mut.scales.length] = s;
      mut.scales[(Math.abs(mut.partHits[i]) + (mut.scales.length / 2)) % mut.scales.length] = s;
    } else if (mut.mode === 2) {
      mut.lines[Math.abs(mut.partHits[i]) % mut.lines.length] = s;
      mut.lines[(Math.abs(mut.partHits[i]) + (mut.lines.length * 0.5)) % mut.lines.length] = s;
      mut.lines[(Math.abs(mut.partHits[i]) + (mut.lines.length * 0.25)) % mut.lines.length] = s;
      mut.lines[(Math.abs(mut.partHits[i]) + (mut.lines.length * 0.75)) % mut.lines.length] = s;
    } else if (mut.mode === 3) {
      mut.scales[Math.abs(mut.partHits[i]) % mut.scales.length] = s;
      mut.scales[(Math.abs(mut.partHits[i]) + (mut.scales.length / 2)) % mut.scales.length] = s;
      mut.lines[Math.abs(mut.partHits[i]) % mut.lines.length] = s;
      mut.lines[(Math.abs(mut.partHits[i]) + (mut.lines.length * 0.5)) % mut.lines.length] = s;
    } else if (mut.mode === 4) {
      mut.scales[Math.abs(mut.partHits[i]) % mut.scales.length] = s;
      mut.scales[(Math.abs(mut.partHits[i]) + (mut.scales.length / 2)) % mut.scales.length] = s;
      mut.lines[Math.abs(mut.partHits[i]) % mut.lines.length] = s;
      mut.lines[(Math.abs(mut.partHits[i]) + (mut.lines.length * 0.5)) % mut.lines.length] = s;
      mut.lines[(Math.abs(mut.partHits[i]) + (mut.lines.length * 0.25)) % mut.lines.length] = s;
      mut.lines[(Math.abs(mut.partHits[i]) + (mut.lines.length * 0.75)) % mut.lines.length] = s;
    }
    inst.synthL.triggerAttackRelease(freq, val.dur * val.hold, time, vel);
    inst.synthR.triggerAttackRelease(freq2, val.dur * val.hold, time, vel2);
    inst.synth3.triggerAttackRelease(freq3, val.dur * val.hold, time, vel2);
    inst.synth3.triggerAttackRelease(freq4, val.dur * val.hold, time, vel2);
    if (Math.random() > 0.9) {
      mut.moving = true;
      setTimeout(() => {
        mut.moving = false;
      }, 1000)
    }
  }), data);

  part.loop = true;
  part.loopStart = 0;
  part.loopEnd = loopEnd;
  return part
}

export default function App() {
  const cam = useRef();
  function click() {
    let val = 2500;
    let fTime = (1000) / 1000;
    inst.filterL.frequency.rampTo(val, fTime * 0.05);
    inst.filterR.frequency.rampTo(val, fTime * 0.05)
    inst.filter3.frequency.rampTo(val, fTime * 0.05)
    setTimeout(() => {
      inst.filterL.frequency.rampTo(inst.defaultFreq, fTime * 0.5);
      inst.filterR.frequency.rampTo(inst.defaultFreq, fTime * 0.5)
      inst.filter3.frequency.rampTo(inst.defaultFreq, fTime * 0.5)
    }, fTime * 50)

    cam.current.autoRotate = true
    cam.current.autoRotateSpeed = -cam.current.autoRotateSpeed
    mut.forward = !mut.forward
    mut.rot += getRand([Math.PI * 0.25, -Math.PI * 0.25])
    mut.radMult = Math.PI
    mut.height = 0.4 + (Math.random() * 0.3)
    mut.size = 1.6 + Math.random() * 0.25
    mut.speed = 1 + (Math.random() * 10)
    mut.mode = getRand([1, 2, 3, 4])

    Tone.context.resume();
    Tone.Transport.start();

    let dTime2 = 0.2 * Math.floor((Math.random() * 2))
    let rTime2 = 0.5 + Math.random() * 0.5
    inst.delay3.delayTime.linearRampToValueAtTime(0.1 + dTime2, rTime2)
    inst.delay3.wet.linearRampToValueAtTime(0.1 + (0.1 * Math.floor((Math.random() * 5))), rTime2)

    let time = 0;
    let dur = 0
    let durMult = getRand([1])
    let durs = [0.2, 0.2, 0.4]
    mut.lower = false
    mut.lowers = new Array(Math.floor(getRand([24]))).fill().map(() => {
      if (Math.random() > 0.9) {
        mut.lower = !mut.lower
      }
      return mut.lower
    })
    let getData = () => Array.from({ length: getRand([3,4]) }, (v, i) => {
      dur = getRand(durs) * durMult;
      let velocity = 0.4 + (Math.random() * 0.2) * dur
      let scale = 1
      let ret = { time, i, dur, velocity, scale, currScale: 1, durMult, hold: 0.05 + (Math.random() * 0.3) }
      time += dur
      return ret
    });

    mut.parts.forEach(part => {
      part.stop();
    });

    let partLen = getRand([2,3])
    new Array(partLen).fill().map((_, i) => {
      let data = getData()
      let loopEnd = time
      let part = createPart(data, loopEnd, partLen, i)
      mut.parts.push(part)
      part.start()
      time = 0
    })
  }
  let isMobile = window.innerWidth < 500

  return (
    <div className="fullscreen" onMouseDown={click}>
      <Canvas dpr={[1, 2]} camera={{ position: [0, isMobile ? 10.5 : 7.5, 0], fov: 45 }} >
        <color attach="background" args={['#000']} />
        <ambientLight intensity={0.5} />
        <directionalLight intensity={0.3} position={[5, 25, 20]} />
        <Orbs amt={amt} spinners={40} />
        <OrbitControls autoRotateSpeed={1.5} ref={cam} maxPolarAngle={-Math.PI} minPolarAngle={-Math.PI} />
      </Canvas>
    </div >

  )
}
let getPos = (t, offset, t2) => {
  const tx = (t * 3 - 1.75) * t;
  const ty = Math.sin(t + (2 * Math.PI * -t * (mut.radMult + mut.radAdd)) * mut.speed) * mut.height;
  const tz = 0;
  vec.set(tx, ty, tz).multiplyScalar((mut.size * t * t))
  return [vec.x, vec.y, vec.z]
}

function Orbs({ amt, spinners }) {
  const ref = useRef();
  let geo1 = new THREE.SphereBufferGeometry(0.4)
  geo1.scale(4, 0.8, 1)
  let geo2 = new THREE.SphereBufferGeometry(0.4)
  geo2.scale(1, 1, 4)
  let mat1 = new THREE.MeshStandardMaterial({
    color: 0xffffff,
  })
  useFrame((state) => {
    let lerpRot = lerp(ref.current.rotation.y, mut.rot, 0.02)
    ref.current.rotation.set(0, lerpRot, 0)
  })
  return (
    <>
      <Instances ref={ref} limit={amt * spinners} material={mat1} geometry={getRand([geo1])}>
        {new Array(spinners).fill().map((_, j) => (
          <group key={j} rotation={[0, (j / spinners) * mut.tp, 0]}>
            {new Array(amt).fill().map((props, i) => (
              <Shoe i={i} amt={amt} j={j} key={i} {...props} />
            ))}
          </group>
        ))}
      </Instances>
    </>
  )
}

function Shoe({ random, i, j, amt, ...props }) {
  const ref = useRef()
  const group = useRef()
  useFrame((state) => {
    const t2 = state.clock.getElapsedTime() * Math.PI
    // ref.current.rotation.set(Math.cos(t / 4) / 2, Math.sin(t / 4) / 2, Math.cos(t / 1.5) / 2)
    let t = i / amt
    mut.offsets[i] += 0.001
    let pos = getPos(t, mut.offsets[i], t2)
    if (i === amt - 1) {
      mut.pos1 = pos
    }
    if (!i) {
      mut.pos0 = pos
    }
    let speed = 0.05
    mut.scales[i] = lerp(mut.scales[i], 1, 0.002)
    mut.lines[j] = lerp(mut.lines[j], 1, 0.002)
    //mut.scales[j] = lerp(mut.scales[j], 1, 0.008)
    ref.current.scale.setScalar(0.01 * (Math.abs(ref.current.position.y) + Math.abs(ref.current.position.x) * 0.2) * mut.scales[i] * mut.lines[j])
    ref.current.position.set(
      lerp(ref.current.position.x, pos[0], speed),
      lerp(ref.current.position.y, pos[1], speed),
      lerp(ref.current.position.z, pos[2], speed),
    );
  })
  return (
    <group ref={group}>
      <Instance ref={ref} />
    </group>
  )
}

console.log('%c🌱🌱 @ramioso 2021-10-27 🌱🌱 ', 'color: orange');